module.exports = __webpack_public_path__ + "static/media/Technologyicon03@3x.6ea7934c.png";